/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTReparent } from './reparent';
export type { KTReparentConfigInterface, KTReparentInterface } from './types';
